import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { create, windowScheduler, keyResolver } from "@yornaath/batshit";
import { CloudForwarderForwarders } from "@graylog/enterprise-api";
const forwarderBatcher = create({
  fetcher: async (ids) => CloudForwarderForwarders.getByIds({ forwarder_ids: ids }),
  resolver: keyResolver("id"),
  scheduler: windowScheduler(10)
});
const useForwarder = (forwarderId) => {
  const { data, isFetching } = useQuery({
    queryKey: ["forwarder", "forwarders", forwarderId],
    queryFn: () => forwarderBatcher.fetch(forwarderId),
    placeholderData: keepPreviousData,
    refetchInterval: 5e3,
    enabled: !!forwarderId
  });
  return { data, isFetching };
};
export default useForwarder;
